import React from "react";
import { FormattedMessage } from "react-intl";
import type { CouponGroup } from "src/coupon-groups/objects/CouponGroup";
import {
  type IRaangeLabelWithFAProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import { BooleanStatusFormatter } from "src/shared/formatters/BooleanStatusFormatter";

export const CouponGroupsLabel = (props: IRaangeLabelWithFAProps) => (
  <RaangeLabel fa="list-alt" {...props}>
    <FormattedMessage id="couponGroups" />
  </RaangeLabel>
);

export interface CouponGroupFormatterProps {
  couponGroup: CouponGroup;
}

export const CouponGroupStatusFormatter = ({
  couponGroup,
}: CouponGroupFormatterProps) => {
  return (
    <BooleanStatusFormatter>
      {couponGroup.couponGroupStatus === "ACTIVE"}
    </BooleanStatusFormatter>
  );
};
